import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from '@mui/material';
import { themeOptions } from './mui-theme';
import { ErrorBoundary } from './components/error-boundary';
import App from './App';
import './index.css';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
   {/* <React.StrictMode> */}
   <ErrorBoundary>
    <ThemeProvider theme={themeOptions}>
      <App />
    </ThemeProvider>
   </ErrorBoundary>
    
   {/* </React.StrictMode>  */}
  </>
 
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
